import * as types from "../mutationTypes";
import api from '../../serve/api'

export default {
    [types.SET_USER](state, data) {
      state.company_id = data.company_id
      state.user = data
      // return new Promise((resolve, reject) => {
      //   api.get('user_token')
      //     .then(
      //       res => {
      //         state.user = res.data
      //         resolve(res)
      //       },
      //       error => {
      //         console.error(error.response)
      //         reject(error.response)
      //       }
      //     )
      // })
    },


    [types.SET_USERS_LIST](state) {
      return new Promise((resolve, reject) => {
        api.get('user')
          .then(
            res => {
              state.users_list = res.data
              resolve(res)
            },
            error => {
              console.error(error.response)
              reject(error.response)
            }
          )
      })
    },


}

